import { formatNumberWithSpaces } from 'utils/index';

export const formatCurrency = (value) =>
  value != null ? `${formatNumberWithSpaces(value.toFixed(0))} €` : '-';

export const formatPercent = (value) => (value != null ? `${value} %` : '-');

export const formatHa = (value) =>
  value != null ? `${formatNumberWithSpaces(value.toFixed(1))} ha` : '-';

export const formatM3 = (value) =>
  value != null ? `${formatNumberWithSpaces(value.toFixed(0))} m³` : '-';

export const formatTMSHa = (value) => (value != null ? `${value} t MS/ha` : '-');

export const formatDecimal = (value) => (value != null ? value.toFixed(2) : '-');

export const formatTonnes = (value) =>
  value != null ? `${formatNumberWithSpaces(value.toFixed(2))} t` : '-';

export const formatYield = (value) => (value != null ? `${value.toFixed(2)} t/ha` : '-');
